import { createSelector } from 'reselect'
import {
    getGroupPosition,
    getMediaPosition
} from 'redux/navigation/selectors'

export const getMediaInfo = state => state.mediaInfo

export const getCurrentMediaInfo = createSelector(
    getMediaInfo,
    getGroupPosition,
    getMediaPosition,
    (mediaInfo, groupPosition, mediaPosition) => {
        if(! mediaInfo[groupPosition])
        {
            return {}
        }
        return mediaInfo[groupPosition][mediaPosition] || {}
    }
)
